// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.carouselContainer_wXiY1 {
  display: flex;
  gap: 10px;
  padding: 10px 0px;
  overflow-x: scroll;
  white-space: nowrap;
  background-color: var(--white-color);
  border: 1px solid #ebebeb;
  border-radius: 8px;
  max-width: 385px;
}

.carouselContainer_wXiY1::-webkit-scrollbar {
  height: 6px;
}

.carouselContainer_wXiY1::-webkit-scrollbar-track {
  background-color: transparent;
  border-radius: 12px;
}

.carouselContainer_wXiY1::-webkit-scrollbar-thumb {
  background-color: #d4d4d4;
  border-radius: 12px;
}

.optionButton_o1Yx8 {
  border: 0px solid #ccc;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: 600;
  word-wrap: break-word;
  white-space: normal;
  overflow-wrap: break-word;
  hyphens: auto;
  padding: 0px;
  height: 40px;
  width: 40px;
  border: 1px solid var(--white-color);
  display: flex;
  align-items: center;
  justify-content: center;
}

.optionButton_o1Yx8:hover {
  border: 1px solid #62ffd8;
}

.selected_KUesy {
  border: 1px solid #13b88e;
}

.optionButton_o1Yx8.selected_KUesy {
  border: 1px solid #13b88e;
  color: var(--white-color);
}

.optionContainer_ZO9hF {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.description_FuuHg {
  margin: 0;
  color: #6a6a6a;
  font-family: Inter;
  font-size: 11px;
  font-weight: 400;
  width: 70px;
  margin-top: 10px;
  text-align: center;
  word-wrap: break-word;
  white-space: normal;
  overflow-wrap: break-word;
  hyphens: auto;
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/Automate/Components/FileInput/selectInfoToProcces/CarouselSelector.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,oCAAoC;EACpC,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;AACf","sourcesContent":[".carouselContainer {\n  display: flex;\n  gap: 10px;\n  padding: 10px 0px;\n  overflow-x: scroll;\n  white-space: nowrap;\n  background-color: var(--white-color);\n  border: 1px solid #ebebeb;\n  border-radius: 8px;\n  max-width: 385px;\n}\n\n.carouselContainer::-webkit-scrollbar {\n  height: 6px;\n}\n\n.carouselContainer::-webkit-scrollbar-track {\n  background-color: transparent;\n  border-radius: 12px;\n}\n\n.carouselContainer::-webkit-scrollbar-thumb {\n  background-color: #d4d4d4;\n  border-radius: 12px;\n}\n\n.optionButton {\n  border: 0px solid #ccc;\n  border-radius: 50%;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-weight: 600;\n  word-wrap: break-word;\n  white-space: normal;\n  overflow-wrap: break-word;\n  hyphens: auto;\n  padding: 0px;\n  height: 40px;\n  width: 40px;\n  border: 1px solid var(--white-color);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.optionButton:hover {\n  border: 1px solid #62ffd8;\n}\n\n.selected {\n  border: 1px solid #13b88e;\n}\n\n.optionButton.selected {\n  border: 1px solid #13b88e;\n  color: var(--white-color);\n}\n\n.optionContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.description {\n  margin: 0;\n  color: #6a6a6a;\n  font-family: Inter;\n  font-size: 11px;\n  font-weight: 400;\n  width: 70px;\n  margin-top: 10px;\n  text-align: center;\n  word-wrap: break-word;\n  white-space: normal;\n  overflow-wrap: break-word;\n  hyphens: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"carouselContainer": `carouselContainer_wXiY1`,
	"optionButton": `optionButton_o1Yx8`,
	"selected": `selected_KUesy`,
	"optionContainer": `optionContainer_ZO9hF`,
	"description": `description_FuuHg`
};
export default ___CSS_LOADER_EXPORT___;
